import { render } from "./direct.vue?vue&type=template&id=02372224&scoped=true"
import script from "./direct.vue?vue&type=script&lang=js"
export * from "./direct.vue?vue&type=script&lang=js"

import "./direct.vue?vue&type=style&index=0&id=02372224&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02372224"]])

export default __exports__